import Fields from '@components/fields'
import Column from '@components/column'

const AccountForm = () => {
  return (
    <Column rowGap={15}>
      <Fields.Input
        label="Full Name"
        name="name"
        placeholder="Enter Full Name"
      />
      <Fields.PhoneInput
        label="Mobile Number"
        name="phoneNo"
        placeholder="Enter Mobile Number"
      />
      <Fields.Input
        type="email"
        name="email"
        label="Email"
        placeholder="Enter Email"
      />
      <Fields.Input
        name="address"
        label="Address"
        placeholder="Enter Address"
      />
      <Fields.Password
        name="password"
        label="Password"
        placeholder="Enter Password"
      />
      <Fields.Password
        name="confirmPassword"
        label="Confirm Password"
        placeholder="Confirm Password"
      />
    </Column>
  )
}

export default AccountForm
